/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosInstance, AxiosResponse } from "axios";

//Function to get cloud connections list data
export function fetchCloudList(
    api: AxiosInstance,
    tenantId: number,
  ): Promise<AxiosResponse> {
  return api.get(`/kontroledge/cloud-connectivity?tenantId=${tenantId}&includeChildServices=true`, {
  });
}

//Function to get the cloud detail
export function fetchCloudConnectionAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}?tenantId=${tenantId}`);
}

//Function to update connection name and tag
export function updateConnectionNameTagAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
  data: { name?: string; tag?: string },
): Promise<AxiosResponse> {
return api.patch(`/kontroledge/cloud-connectivity/${connectionId}?tenantId=${tenantId}`, data);
}

//Function to get the cloud performance chart
export function fetchCloudPerformanceAPI(
  api: AxiosInstance,
  connectionId: string,
  timeRange: string,
  interval: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}/performance`, {
  params: { timeRange, interval, tenantId},
});
}

//Function to get the cloud subscription Info
export function fetchCloudSubscriptionAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}/subscription?tenantId=${tenantId}`);
}

//Function to get the cloud errors
export function fetchCloudErrorsAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}/crc-errors?timeRange=1d&tenantId=${tenantId}`, {
});
}

//Function to get the cloud connectivity provider
export function fetchCloudProvidersAPI(
  api: AxiosInstance,
  connectionId: string,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/cloud-connectivity/${connectionId}/provider?tenantId=${tenantId}`, {
});
}